import React from 'react';
import { FiHome, FiUser, FiImage, FiBriefcase, FiCalendar, FiGrid } from 'react-icons/fi';
import { Link, useLocation } from '@tanstack/react-router';
import { LiquidGlass } from '@liquidglass/react';

export const BottomNav: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const navItems = [
    { label: 'Home', icon: FiHome, path: '/' },
    { label: 'Media', icon: FiImage, path: '/media' },
    { label: 'Services', icon: FiGrid, path: '/services' },
    { label: 'Gigs', icon: FiBriefcase, path: '/gigs' },
    { label: 'Events', icon: FiCalendar, path: '/events' },
    { label: 'Profile', icon: FiUser, path: '/profile' },
  ];

  return (
    <>
      {/* Blurred Backdrop Mask (Smooth scrolling behind nav) */}
      <div
        className="md:hidden fixed bottom-0 left-0 right-0 h-40 pointer-events-none z-40 bg-linear-to-t from-black via-black/80 to-transparent backdrop-blur-sm"
        style={{
          maskImage: 'linear-gradient(to top, black 20%, transparent 100%)',
          WebkitMaskImage: 'linear-gradient(to top, black 20%, transparent 100%)',
        }}
      />

      <nav className="md:hidden fixed bottom-6 left-1/2 -translate-x-1/2 z-40 w-[92%] max-w-130">
        {/* The "Liquid Glass" Professional Component */}
        <LiquidGlass
          borderRadius={32}
          blur={20}
          contrast={1.1}
          brightness={1.2}
          saturation={1.3}
          shadowIntensity={0.5}
          displacementScale={1.2}
          elasticity={0.8}
          className="p-0"
        >
          <div className="flex items-center w-full py-3 px-1.5 border border-white/20 rounded-4xl bg-black/70 backdrop-blur-xl">
            {navItems.map((item) => {
              // Normalize paths for comparison (remove trailing slashes)
              const normalizedPath = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
              const normalizedItemPath = item.path === '/' ? '/' : item.path.replace(/\/$/, '');

              const isActive =
                normalizedItemPath === '/'
                  ? normalizedPath === '/'
                  : normalizedPath.startsWith(normalizedItemPath);

              const Icon = item.icon;

              return (
                <Link
                  key={item.label}
                  to={item.path}
                  className="flex-1 flex flex-col items-center gap-1.5 transition-all duration-500 group no-underline"
                >
                  <div
                    className={`p-2.5 rounded-2xl transition-all duration-500 ${isActive ? 'bg-white/25 scale-110 shadow-[0_0_30px_rgba(255,255,255,0.25)]' : 'group-active:scale-95'}`}
                  >
                    <Icon
                      size={20}
                      strokeWidth={isActive ? 2.8 : 2.2}
                      className={isActive ? 'text-white' : 'text-white/80'}
                    />
                  </div>
                  <span
                    className={`text-[10.5px] font-bold uppercase tracking-[0.08em] transition-all duration-500 text-center truncate w-full px-1 ${isActive ? 'opacity-100 text-white translate-y-0' : 'opacity-80 text-zinc-300 translate-y-0'}`}
                  >
                    {item.label}
                  </span>
                </Link>
              );
            })}
          </div>
        </LiquidGlass>
      </nav>
    </>
  );
};
